import { SxProps, Theme } from '@mui/material/styles';
import { DPP_DARK } from '@/components/blocks/DpRepurchaseCoupon/styles/hero';

export const sectionHeaderSX: SxProps<Theme> = {
	mb: { xs: '16px', md: '20px' },
	display: 'flex',
	flexDirection: { xs: 'column', md: 'row' },
	alignItems: { xs: 'flex-start', md: 'flex-end' },
	justifyContent: 'space-between',
	gap: { xs: '8px', md: '24px' },
	scrollMarginTop: '96px',
};

export const sectionHeaderTextSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: '4px',
};

export const sectionEyebrowSX: SxProps<Theme> = {
	m: 0,
	fontSize: '11px',
	fontWeight: 700,
	letterSpacing: '0.16em',
	textTransform: 'uppercase',
	color: DPP_DARK,
};

export const sectionTitleSX: SxProps<Theme> = {
	m: 0,
	fontSize: { xs: '24px', md: '28px' },
	fontWeight: 800,
	lineHeight: 1.1,
	textTransform: 'uppercase',
	color: '#2c2c2c',
};

export const sectionSubtitleSX: SxProps<Theme> = {
	m: 0,
	fontSize: { xs: '13px', md: '14px' },
	lineHeight: 1.45,
	color: '#505050',
};

export const sectionChipSX: SxProps<Theme> = {
	flexShrink: 0,
	px: '12px',
	py: '6px',
	borderRadius: '999px',
	background: '#F6F0FA',
	color: DPP_DARK,
	fontSize: '12px',
	fontWeight: 700,
	whiteSpace: 'nowrap',
};
